module.exports = __webpack_public_path__ + "img/06.ffd5798b.jpg";